import { ObservationStatusIssue } from "./observation-status-issue";

export enum ObservationStatus {
	PROCESSED = "PROCESSED",
	ISSUE = "ISSUE",
	ERROR = "ERROR",
	ONGOING = "ONGOING",
	REVIEWING = "REVIEWING",
	REJECTED = "REJECTED",
	WAITING_FOR_DIV = "WAITING_FOR_DIV",
}

export class ObservationStatusResponse{
	Issues:ObservationStatusIssue[] = [];
	Status:ObservationStatus = ObservationStatus.ONGOING;

	public constructor(data:any){
		this.Status = data.Status;
		this.Issues = (data.Issues || []).map((d:any)=>new ObservationStatusIssue(d));
	}
}